import { Loading } from '@angeplus/prever-component-lib';

import { useHasBenefit } from 'modules/contract/contract.store';
import { PetAssistanceBenefit } from './PetAssistanceBenefit';
import { PetAssistanceBenefitContractEmptyState } from './PetAssistanceBenefitContractEmptyState';
import { PetAssistanceBenefitEmptyState } from './PetAssistanceBenefitEmptyState';

export const PetAssistanceHasBenefit = () => {
  const query = useHasBenefit();

  if (query?.isLoading) {
    return <Loading />;
  }

  if (!query?.data?.contract_active?.is_valid && !query?.data?.allowed_usage) {
    return <PetAssistanceBenefitContractEmptyState />;
  }

  if (query?.data?.allowed_usage) {
    return <PetAssistanceBenefit />;
  }

  return <PetAssistanceBenefitEmptyState />;
};
